import React from "react";
import useStore from "../store";
import strings from "../lang/Localiz";
import SuperPrizeList from "./SuperPrizeList";
import CommonPrizeList from "./CommonPrizeList";
import ScrollComponent from "./ScrollComponents";

function SingleStore(props) {
    const lvl = props.lvl;
    const current = props.current;
    const current_lvl = current === lvl;
    const givePrize = props.givePrize;

    const crystal_cur = useStore((state) => state.crystal);
    const repair_cur = useStore((state) => state.repair);
    const protection_cur = useStore((state) => state.protection);
    const damage_cur = useStore((state) => state.damage);
    const boost_cur = useStore((state) => state.boost);

    const common_key_cur = useStore((state) => state.common_key);
    const rare_key_cur = useStore((state) => state.rare_key);
    const epic_key_cur = useStore((state) => state.epic_key);
    const grenade_cur = useStore((state) => state.grenade);
    const snowball_cur = useStore((state) => state.snowball);
    const king_cur = useStore((state) => state.king);
    const firework_cur = useStore((state) => state.firework);

    const crystal = givePrize
        ? givePrize.crystal
        : current_lvl
            ? crystal_cur
            : "???";
    const common_key = givePrize
        ? givePrize.common_key
        : current_lvl
            ? common_key_cur
            : "???";
    const rare_key = givePrize
        ? givePrize.rare_key
        : current_lvl
            ? rare_key_cur
            : "???";
    const epic_key = givePrize
        ? givePrize.epic_key
        : current_lvl
            ? epic_key_cur
            : "???";
    const grenade = givePrize
        ? givePrize.grenade
        : current_lvl
            ? grenade_cur
            : "???";
    const snowball = givePrize
        ? givePrize.snowball
        : current_lvl
            ? snowball_cur
            : "???";
    const king = givePrize
        ? givePrize.king
        : current_lvl
            ? king_cur
            : "???";
    const firework = givePrize
        ? givePrize.firework
        : current_lvl
            ? firework_cur
            : "???";

    const repair = givePrize
        ? givePrize.repair
        : current_lvl
            ? repair_cur
            : "???";
    const protection = givePrize
        ? givePrize.protection
        : current_lvl
            ? protection_cur
            : "???";
    const damage = givePrize
        ? givePrize.damage
        : current_lvl
            ? damage_cur
            : "???";
    const boost = givePrize ? givePrize.boost : current_lvl ? boost_cur : "???";

    const lang = strings.getLanguage();
    return (
        <div
            className={
                givePrize
                    ? "single-store access"
                    : current_lvl
                        ? "single-store current-denied"
                        : "single-store future"
            }
        >
            <div className={"single-store-name"}>
                <div className={"hud_info_island_now"}/>
                {strings.checkpoint.title} {lvl + 1}
            </div>

            <ScrollComponent orientation="vertical" lockWheel className={"single-store-prize"}>
                <CommonPrizeList
                    lang={lang}
                    showCommonKey={!(lvl === 0)}
                    showRareKey={!(lvl === 0)}
                    showEpicKey={!(lvl === 0)}
                    showGrenade={false}
                    showSnowball={lvl > 1 && lvl < 5}
                    showKing={lvl > 4}
                    showFirework={lvl === 1}
                    showCrystals={false}
                    showDamage={false}
                    showBoost={false}
                    showRepair={false}
                    showProtection={false}
                    common_key={common_key}
                    rare_key={rare_key}
                    epic_key={epic_key}
                    grenade={grenade}
                    snowball={snowball}
                    king={king}
                    firework={firework}
                    crystal={crystal}
                    damage={damage}
                    boost={boost}
                    repair={repair}
                    protection={protection}
                />
                <SuperPrizeList
                    point_one={lvl === 0}
                    point_two={lvl === 1}
                    point_three={lvl === 2}
                    point_four={lvl === 3}
                    point_five={lvl === 4}
                    point_six={lvl === 5}
                    point_seven={lvl === 6}
                />
            </ScrollComponent>
            <div className={"single-store-status"}>
                <div className={"single-store-status-icon"}/>
                <div className={"single-store-status-txt"}>
                    {givePrize && strings.checkpoint.claimed}
                    {!givePrize && strings.checkpoint.next}
                </div>
            </div>
        </div>
    );
}

export default SingleStore;
